import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';

import {getCatalogo} from '../../../pages/requests';
import NotFound from '../../NotFound';
import {Lan} from '@mui/icons-material';
import SelectComponent from '../../Selects/SelectComponent';

import {
    getDados,
    getSubtipos,
    getEstabelecimentos,
    postNegocio,
    getNegociosId,
    getContactosProspect,
    getRepresentantes,
    getOrigens,
    getMoedas,
    getMarcas,
    getTipos,
    getModelos,
    getNacionaisInternacionais,
    getCategoriasArtigos,
    getVersoes,
    getDuracaoCF,
    getCarenciaCF,
    getNumRendaCF,
    getPortesMesCF,
    getSeguroRespCivilCF,
    getTaxaNominalCF,
    getEntradaInicialCF,
    getRendaMensalCF,
    getValorResidualCF,
    getSeguroCascoMesCF,
    getDespesaContratoCF,
} from '../../../pages/requests';
import SelectMaquinaProposta from '../../Selects/SelectMaquinaProposta';

function Artigos({
    info,

    setLinhasArtigos,
    linhasArtigos,
}) {
    const totalLinhas = linhasArtigos.length;

    const {
        editarNegocio,
        setOnChangeForm,

        moedas,
        setDivisaR,
        divisaR,
        setValidacaoDivisa,
        ValidacaoDivisa,

        setValor,
        valor,
        setValidacaoValor,
        validacaoValor,

        marcas,
        nacionaisInternacionais,
        tipos,
        modelos,
        categoriasArtigos,
        optionsVersao,
        setMoedas,
        setCategoriasArtigos,
        setMarcas,
        setNacionaisInternacionais,
        setTipos,
        setModelos,
        setOptionsVersao,
    } = info;

    const {t} = useTranslation();
    const [artigos, setArtigos] = useState([]);
    const {utilizador, verifAuthenticated} = useContext(Context);

    const [industria, setIndustria] = useState('');
    const [marca, setMarca] = useState('');
    const [tipo, setTipo] = useState('');
    const [modelo, setModelo] = useState('');

    const [validacaoMarca, setValidacaoMarca] = useState(false);
    const [validacaoTipo, setValidacaoTipo] = useState(false);
    const [validacaoModelo, setValidacaoModelo] = useState(false);

    // FILTROS
    const [filtroArtigo, setFiltroArtigo] = useState('');
    const [filtroValor, setFiltroValor] = useState('');

    const [semDados, setSemDados] = useState(false);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const artigosFilt = linhasArtigos.filter(x =>
        //x.descricao?.toUpperCase().includes(filtroArtigo?.toUpperCase()) &&
        x.preco.toString()?.toUpperCase().includes(filtroValor?.toUpperCase()),
    );

    const handleChildChange = (element, index) => {
        const updatedData = [...linhasArtigos];
        updatedData[index] = element;
        setLinhasArtigos(updatedData);
    };
    const adicionarNovaLinha = () => {
        setLinhasArtigos(prev => [
            ...prev,
            {
                idLinha: Math.random() * 999999,
                referencia: '',
                descricao: '',
                preco: 0,
                categoria: null,
                marca: null,
                tipo: null,
                modelo: null,
                versao: null,
                observacoes: '',
            },
        ]);
    };

    const eliminarLinha = id => {
        debugger;
        const novasLinhas = linhasArtigos.filter(linhaArtigo => linhaArtigo.idLinha !== id);

        setLinhasArtigos(novasLinhas);
    };

    useEffect(() => {
        if (linhasArtigos.length == 0) {
            setLinhasArtigos([
                {
                    idLinha: Math.random() * 999999,
                    referencia: '',
                    descricao: '',
                    preco: 0,
                    categoria: null,
                    marca: null,
                    tipo: null,
                    modelo: null,
                    versao: null,
                    observacoes: '',
                },
            ]);
        }
        if (moedas.length == 0) {
            getMoedas(lang).then(res => {
                setMoedas(res.data.moedas);
            });

            getCategoriasArtigos(lang).then(res => {
                if (res.data.success) {
                    setCategoriasArtigos(res.data.categorias);
                }
            });

         

            getNacionaisInternacionais(lang).then(res => {
                if (res.data.success) {
                    setNacionaisInternacionais(res.data.nacionaisInternacionais);
                }
            });

            getTipos(lang).then(res => {
                setTipos(res.data.tipos);
            });
           
            getModelos(lang).then(res => {
                setModelos(res.data.modelos);
            });

            getVersoes(lang).then(res => {
                if (res.data.success) {
                    setOptionsVersao(res.data.versoes);
                }
            });
        }
    }, []);
console.log(modelos, "modelos");
    const [controllerAbort, setControllerAbort] = useState();

    async function Getartigos(search, categoria, marca, nacinternac, familia, modelo, versao) {
        if (search.length >= 3) {
            debugger;
            if (controllerAbort) {
                controllerAbort.abort();
            }
            let controlerA = new AbortController();
            setControllerAbort(controlerA);

            getCatalogo(
                0,
                9999,
                'POR',
                controlerA.signal,
                search,
                categoria ? [categoria] : [],
                marca ? [marca] : [],
                nacinternac ? [nacinternac] : [],
                familia ? [familia] : [],
                modelo ? [modelo] : [],
                versao ? [versao] : [],
            )
                .then(res => {
                    if (res.data.success) {
                        setArtigos(res.data.produtos);
                    }
                })
                .catch(console.log);
        } else {
            setArtigos([]);
        }
    }

    useEffect(() => {
        setValor(
            linhasArtigos
                .filter(l => l.referencia)
                .map(l => Number(l.preco))
                .reduce((a1, a2) => a1 + a2, 0),
        );
        setValidacaoValor(false);
    }, [linhasArtigos]);

    useEffect(() => {
        if (artigosFilt.length != 0) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [artigosFilt]);

    return (
        <>
            <form className="mt-4">
                <div className="grid gap-3 mb-6 md:grid-cols-2">
                    <div>
                        <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('divisa')}*
                        </label>
                        <SelectComponent
                            options={moedas}
                            value={divisaR}
                            onChange={e => {
                                setDivisaR(e);
                                setOnChangeForm(true);
                                setValidacaoDivisa(false);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                            isDisabled={!editarNegocio}
                        />
                        {ValidacaoDivisa && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                    </div>
                    <div>
                        <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('montante')}*
                        </label>
                        <input
                            type="text"
                            value={valor}
                            // defaultValue={observacoes}
                            maxLength={50}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${
                                validacaoValor ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                            } ${!editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                            onChange={e => {
                                setValor(e.target.value);
                                //  setValidacaoObs(false);
                                setValidacaoValor(false);
                                setOnChangeForm(true);
                            }}
                            required
                            disabled={!editarNegocio}
                        />
                    </div>
                </div>
                <div>
                    <div className="relative min-h-[400px]  overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-3 py-3">
                                        {t('categoria')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('marca')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('nacionalInternacional')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('tipo')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('modelo')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('versao')}
                                        {/* <InputFilter
                                            onSearch={value => {
                                                //setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-3 py-3">
                                        {t('artigo')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                setFiltroArtigo(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-4">
                                        {t('valor')}*
                                        {/* <InputFilter
                                            onSearch={value => {
                                                setFiltroValor(value);
                                            }}
                                        /> */}
                                    </th>
                                    <th scope="col" className="px-4">
                                        {t('observacoes')}
                                        {/* <InputFilter
                                            onSearch={value => {
                                                setFiltroValor(value);
                                            }}
                                        /> */}
                                    </th>

                                    <th scope="col" className="px-6 py-3"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {linhasArtigos?.map((row, rowIndex) => (
                                    <tr key={rowIndex} className="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                                        <td className="px-3 py-4">
                                            <SelectComponent
                                                options={categoriasArtigos}
                                                value={row.categoria}
                                                onChange={e => {
                                                    setOnChangeForm(true);
                                                    row.categoria = e;
                                                    row.validacaoCategoria = false;
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoCategoria && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectComponent
                                                options={marcas.filter(o => o.dep === row.categoria?.value)}
                                                value={row.marca}
                                                onChange={e => {
                                                    setOnChangeForm(true);
                                                    row.marca = e;
                                                    row.validacaoMarca = false;
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoMarca && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectComponent
                                                options={nacionaisInternacionais.filter(o => o.dep === row.marca?.value)}
                                                value={row.nacionalInternacional}
                                                onChange={e => {
                                                    setOnChangeForm(true);
                                                    row.nacionalInternacional = e;
                                                    row.validacaoNacionalInternacional = false;
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoNacionalInternacional && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectMaquinaProposta
                                                options={tipos.filter(o => o.dep === row.nacionalInternacional?.value)}
                                                value={row.tipo}
                                                onChange={e => {
                                                    row.tipo = e;
                                                    row.validacaoTipo = false;
                                                    setOnChangeForm(true);
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoTipo && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectComponent
                                                options={!row.tipo ? modelos : modelos.filter(item => item.dep === row.tipo?.value)}
                                                value={row.modelo}
                                                onChange={e => {
                                                    row.modelo = e;
                                                    row.validacaoModelo = false;
                                                    setOnChangeForm(true);
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoModelo && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectComponent
                                                options={!row.modelo ? optionsVersao : optionsVersao.filter(item => item.dep === row.modelo?.value)}
                                                value={row.versao}
                                                onChange={e => {
                                                    row.versao = e;
                                                    row.validacaoVersao = false;
                                                    setOnChangeForm(true);
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoVersao && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-3 py-4">
                                            <SelectMaquinaProposta
                                                options={artigos}
                                                value={
                                                    row.referencia
                                                        ? {
                                                              label: row.referencia + ' - ' + row.descricao,
                                                              value: row.referencia,
                                                          }
                                                        : ''
                                                }
                                                onInputChange={e => {
                                                    Getartigos(
                                                        e,
                                                        row.categoria?.value ?? '',
                                                        row.marca?.value ?? '',
                                                        row.nacionalInternacional?.value ?? '',
                                                        row.tipo?.value ?? '',
                                                        row.modelo?.value ?? '',
                                                        row.versao?.value ?? '',
                                                    );
                                                }}
                                                onChange={e => {
                                                    row.referencia = e.id;
                                                    row.descricao = e.nome;
                                                    row.preco = e.preco;
                                                    row.validacaoArtigos = false;
                                                    handleChildChange(row, rowIndex);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('pesquisa')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {row.validacaoArtigos && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </td>
                                        <td className="px-6 py-4">
                                            <input
                                                type="number"
                                                // defaultValue={t("concorrente")}
                                                value={row.preco}
                                                placeholder={t('valor')}
                                                className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm  dark:border-gray-700 ${
                                                    !editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                                }`}
                                                onChange={e => {
                                                    var valor = Object.assign({}, row);
                                                    valor.preco = e.target.value;
                                                    handleChildChange(valor, rowIndex);
                                                }}
                                                disabled={!editarNegocio}
                                            />
                                        </td>
                                        <td className="px-6 py-4">
                                            <input
                                                type="text"
                                                value={row.observacoes}
                                                className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm  dark:border-gray-700 ${
                                                    !editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                                }`}
                                                onChange={e => {
                                                    var obs = Object.assign({}, row);
                                                    obs.observacoes = e.target.value;
                                                    handleChildChange(obs, rowIndex);
                                                }}
                                                disabled={!editarNegocio}
                                            />
                                        </td>

                                        <td className="px-2 py-4">
                                            {totalLinhas === rowIndex + 1 && row.ref !== '' && editarNegocio && (
                                                <button className={`mt-2 rounded-full p-1 ${'bg-blue-600'} text-white`}>
                                                    <AddRoundedIcon onClick={adicionarNovaLinha} />
                                                </button>
                                            )}
                                            {totalLinhas != rowIndex + 1 && editarNegocio && (
                                                <button type="button" className={`mt-2 rounded-full p-1 ${'bg-red-600'} text-white`} onClick={() => eliminarLinha(row.idLinha)}>
                                                    <DeleteForeverRoundedIcon />
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default Artigos;
